import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader } from "@/components/ui/dialog";
import { DialogTitle } from "@radix-ui/react-dialog";

export function AlertDialog({
  open,
  onOpenChange,
  message,
  status
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  message: string;
  status: boolean;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{status === true ? "Success" :  "Error"}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <p className="text-gray-600">{message}</p>
          <div className="flex justify-end">
            <Button
              type="button"
              variant="default"
              onClick={() => onOpenChange(false)}
            >
              Close
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
